<cf-form-field class="text-start">
  @if (label()) {
    <cf-input-label weight="500" size="md" [required]="required()">
      {{ label() }}
    </cf-input-label>
  }

  <div cf-input-prefix>
    <cf-dropdown placement="bottom-left">
      <div class="d-flex align-items-center" cf-dropdown-toggle>
        <svg [flag]="selectedCountry.code.toLowerCase()"></svg>
        <svg cfIcon="chevron_down" size="sm" class="tw:ml-1 tw:text-gray-70"></svg>
      </div>

      <input
        cf-input
        cf-dropdown-filter
        class="dropdown-input-filter size--md"
        type="text"
        [placeholder]="'forms.phone_number.countries_filter_placeholder' | translate"
        [(ngModel)]="searchText"
        (input)="filterCountries()"
      />

      <div class="dropdown-items" cf-dropdown-items>
        @for (country of filteredCountries; track $index) {
          <cf-dropdown-item (click)="onCountrySelect(country)">
            <div class="d-flex">
              <div class="d-flex flag">
                <svg [flag]="country.code.toLowerCase()"></svg>
                <cf-text size="sm" class="ms-1">{{ country.dialCode }}</cf-text>
              </div>
              <cf-text size="sm" className="text-cut text-break max-1" class="ms-2">{{ country.name }}</cf-text>
            </div>
          </cf-dropdown-item>
        }
      </div>
    </cf-dropdown>
  </div>

  <input
    cf-input
    type="text"
    class="phone-input"
    [maskito]="mask"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="onPhoneInput($event)"
    (paste)="onPaste($event)"
  />
</cf-form-field>
